export enum Environments {
    LOCAL = 'LOCAL',
    DEVELOPMENT = 'DEVELOPMENT',
    PRODUCTION = 'PRODUCTION'
}
